export default __webpack_public_path__ + "static/media/portfolio-42.7c0b5122.jpg";